<template>
  <a :href="story.content.link" target="_blank" class="news-entry">
    <div class="news-entry__logo-wrapper">
      <BaseNuxtImage
        :style="logoStyle"
        class="news-entry__logo"
        :src="imgSrc"
        :alt="imgAlt"
      />
    </div>
    <div class="news-entry__info">
      <h6 class="news-entry__title mb-12">{{ story.content.title }}</h6>
      <div class="news-entry__date paragraph--s">{{ story.content.date }}</div>
    </div>
  </a>
</template>

<script lang="ts" setup>
import type { SbNewsroomNewsEntryStoryblok } from '@/types'

interface Props {
  story: SbNewsroomNewsEntryStoryblok
  paperBackground?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  story: {},
  paperBackground: false,
})

const imgSrc = computed(() => {
  return props.story.content.logo?.filename || ''
})

const imgAlt = computed(() => {
  return props.story.content.logo?.alt || ''
})

const logoStyle = computed(() => {
  return {
    maxWidth: `${props.story.content?.logo_max_width || 1000}px`,
  }
})
</script>

<style lang="scss" scoped>
.news-entry {
  @include shadow-grey-small;

  $root: #{&};
  display: flex;
  flex-direction: column;
  color: var(--color-text);
  background-color: var(--white);
  padding: 40px;
  border-radius: 20px;
  height: 330px;

  &:hover {
    text-decoration: none;

    #{$root}__title {
      color: var(--color-link);
    }
  }
  &__logo {
    height: auto;
  }
  &__logo-wrapper {
    flex-grow: 1;
  }
}
</style>
